import { useEffect, useState } from "react";
import { Grid, Typography, useTheme } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Label,
} from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = {
  complete: "#17afb6",
  remaining: "#e0e0e0",
};

export default function SocietyCompletionChart({ compliances }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    if (!compliances || compliances.length === 0) {
      setData([]);
      setPercentage(0);
      return;
    }

    const total = compliances.length;
    const complete = compliances.filter(
      (c) => c.status === "complete"
    ).length;
    const pct = Math.round((complete / total) * 100);

    setPercentage(pct);
    setData([
      { name: t("Complete"), value: complete, color: COLORS.complete },
      {
        name: t("Remaining"),
        value: total - complete,
        color: COLORS.remaining,
      },
    ]);
  }, [compliances, t]);

  return (
    <Grid item xs={12} sm={6} md={6}>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="90%"
              startAngle={90}
              endAngle={-270}
              stroke="none"
              isAnimationActive={true}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}

              <Label
                value={`${percentage}%`}
                position="center"
                style={{
                  fill: COLORS.complete,
                  fontSize: 28,
                  fontWeight: 700,
                }}
              />
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: 8,
                border: `1px solid ${theme.palette.divider}`,
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <Typography variant="subtitle1" align="center" sx={{ mb: 2 }}>
        {t("Overall completion")}
      </Typography>
    </Grid>
  );
}
